module.exports = __webpack_public_path__ + "img/btn_settings_active.b85c3cac.svg";